import { render, staticRenderFns } from "./Startup.vue?vue&type=template&id=12662970&scoped=true"
import script from "./Startup.vue?vue&type=script&lang=ts"
export * from "./Startup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12662970",
  null
  
)

export default component.exports